export default "__VITE_ASSET__9b18feab__"